import { BsDash, BsArrowRight } from 'react-icons/bs';
import { useNavigate } from "react-router-dom";
import Fade from 'react-reveal/Fade';

const ProjectComponent = ({ project, isLastOnPage, isReverse = false }) => {

    const navigate = useNavigate();

    return (
        <div className='h-full bg-primary overflow-hidden pt-12 '>
            <div className={` px-[30px] flex flex-col-reverse gap-[60px] ${isReverse ? "md:flex-row-reverse" : "md:flex-row"}`} >
                <div className="basis-[50%] px-[20px] gap-[15px] flex flex-col justify-center">
                    <p className='flex text-accent items-center text-[16px] font-poppins'><BsDash /> Project {project.id}</p>
                    <Fade bottom>
                        <div >
                            <h1 onClick={() => { navigate(`/portfolio/${project.id}`) }} className='cursor-pointer font-montserrat text-[25px] lg:text-[38px] font-[650] lg:font-[600] leading-[2.5rem] md:leading-[3rem] text-white'>{project.title}</h1>
                            <p className='text:[14px] lg:text-[18px] font-poppins font-[350] tracking-[0.05em] text-ash'>{project.shortDesc}</p>
                        </div>
                    </Fade>
                    <Fade right duration={1000} delay={300}>
                        <button onClick={() => { navigate(`/portfolio/${project.id}`) }} className='flex text-secondary items-center text-[18px] mt-4 font-montserrat cursor-pointer'><BsArrowRight className='text-[22px] font-bold mr-4' /> <span className='hover:ml-4 transition-all duration-500'>Read More</span></button>
                    </Fade>
                </div>
                <div className="basis-[50%] relative">
                    <div className='h-[350px] md:h-[400px] lg:h-[500px] w-full bg-[#424246] rotate-[-10deg] rounded-[45px]'></div>
                    <a target="_blank" href={project.projectLink} className="h-[300px] md:h-[400px] lg:h-[500px] w-full rounded-[45px] absolute top-0 shadow-lg shadow-primary bg-cover bg-center bg-no-repeat" style={{ backgroundImage: `url(${project.imgPath})` }}>
                    </a>
                </div>

            </div>
            {!isReverse && !isLastOnPage &&
                <Fade right>
                    <div className='h-[200px] w-[200px] rounded-[50%] bg-gradient-to-b from-accent to-primary  flex items-center justify-center my-[40px] relative right-[-80%]'>
                        <div className='h-[130px] w-[130px] rounded-[50%] bg-primary'>
                        </div>
                    </div>
                </Fade>
            }
            {
                isReverse && !isLastOnPage &&
                <Fade left>
                    <div className='h-[250px] w-[250px] rounded-[50%] bg-gradient-to-b from-secondary to-primary  flex items-center justify-center my-[60px] relative left-[-70px]'>
                        <div className='h-[200px] w-[200px] rounded-[50%] bg-primary'>
                        </div>
                    </div>
                </Fade>
            }
        </div>
    );
}

export default ProjectComponent;